import i18n from '../../../lib/i18n';

export const describesYou = [
	{ label: i18n.t('Lesbian or gay'), value: '1'},
  { label: i18n.t('Bisexual'), value: '3'},
  { label: i18n.t('Straight that is, not gay or lesbian'), value: '2'},
  { label: i18n.t('I don\'t know'), value: '5'},
  { label: i18n.t('I use a different term'), value: '4'},
  { label: i18n.t('Choose not to answer'), value: '6'},
];

export const sex = [
  { label: i18n.t('Male'), value: 'M' },
  { label: i18n.t('Female'), value: 'F' }
];
  
export const gender = [
  { label: i18n.t('Woman'), value: '1'},
  { label: i18n.t('Man'), value: '2'},
  { label: i18n.t('Non-Binary'), value: '3'},
  { label: i18n.t('I use a different term'), value: '4'},
  { label: i18n.t('Choose not to answer'), value: '5'},
];
  
export const race = [
  { label: i18n.t('White'), value: '101' },
  { label: i18n.t('Black or African American'), value: '201' },
  { label: i18n.t('American Indian or Alaska Native'), value: '300' },
  { label: i18n.t('Asian Indian'), value: '401' },
  { label: i18n.t('Chinese'), value: '411' },
  { label: i18n.t('Filipino'), value: '421' },
  { label: i18n.t('Japanese'), value: '431' },
  { label: i18n.t('Korean'), value: '441' },
  { label: i18n.t('Vietnamese'), value: '451' },
  { label: i18n.t('Other Asian'), value: '499' },
  { label: i18n.t('Native Hawaiian'), value: '501' },
  { label: i18n.t('Samoan'), value: '511' },
  { label: i18n.t('Guamanian or Chamorro'), value: '521' },
  { label: i18n.t('Other Pacific Islander'), value: '599' },
  { label: i18n.t('I choose not to answer'), value: '999' }
];

export const ethnicity = [
  { label: i18n.t('Not of Hispanic, Latino or Spanish Origin'), value: 'NA' },
  { label: i18n.t('Puerto Rican'), value: 'PR' },
  { label: i18n.t('Another Hispanic, Latino or Spanish Origin'), value: 'OTH' },
  { label: i18n.t('Mexican, Mexican American, Chicano/a'), value: 'MX' },
  { label: i18n.t('Cuban'), value: 'CUB' },
  { label: i18n.t('I choose not to answer'), value: 'NR' }
];
  
export const language = [
  { label: i18n.t('English'), value: 'ENG' },
  { label: i18n.t('Spanish'), value: 'SPA' },
  { label: i18n.t('Creole'), value: 'CRE' }
];
    
export const accessibleFormats = [
  { label: i18n.t('Braile'), value: 'BRL' },
  { label: i18n.t('Audio Tape'), value: 'AUD' },
  { label: i18n.t('Large print'), value: 'LRG' },
  { label: i18n.t('Other'), value: 'OTH' }
];

export const healthConditionsCardio = [
  { type: 'cardio', value: '1', label: i18n.t('Have you had or been told you need heart surgery?') },
  { type: 'cardio', value: '2', label: i18n.t('Have you had a stent placed in your heart?') },
  { type: 'cardio', value: '3', label: i18n.t('Do you have a pacemaker or take any medications for abnormal heart rhythm?') },
  { type: 'cardio', value: '4', label: i18n.t('Has your doctor told you that you have reduced blood flow to your legs or feet?') },
  { type: 'cardio', value: '5', label: i18n.t('Have you ever had a procedure to improve circulation to your legs or feet?') },
  { type: 'cardio', value: '6', label: i18n.t('Do you suffer from blood clots or are you taking any long-term medications for blood clots?') },
  { type: 'cardio', value: '7', label: i18n.t('Do you take any medications for your heart or circulation?') },
  { type: 'cardio', value: '8', label: i18n.t('Has your doctor told you that your heart is not pumping as well as it should?') },
  { type: 'cardio', value: '9', label: i18n.t('Do you have swelling in your feet & legs almost every day due to too much fluid in your body?') },
  { type: 'cardio', value: '12', label: i18n.t('Have you been prescribed a diuretic due to a heart-related condition?') }];

export const healthConditionsDiabetes = [ 
  { type: 'diabetes', value: '4', label: i18n.t('Have you been advised by a doctor to regularly check your blood sugar?') },
  { type: 'diabetes', value: '2', label: i18n.t('Have you been diagnosed with high blood sugar (diabetes)?') },
  { type: 'diabetes', value: '3', label: i18n.t('Do you take any medications to control your blood sugar?') }
];

export const PCPPatientOptions = [
  { label: i18n.t('Yes'), value: 'yes' },
  { label: i18n.t('No'), value: 'no' },
  { label: i18n.t('Other'), value: 'other' }
];

export const accessibilityOptionsList = [
  { label: i18n.t('Evidence of Coverage'), value: '1' },
  { label: i18n.t('OTC Catalog'), value: '2' },
  { label: i18n.t('Formulary'), value: '3' }
];
  
export const paymentOptions = [
  {
    label: i18n.t('Get a bill'),
    value: "1",
  },
  {
    label: i18n.t('Deduction from Social Security'),
    value: "2",
  },
  {
    label: i18n.t('Deduction from RRB'),
    value: "3",
  }
];

export const authorizedRepresentativeOptions = [
  { label: i18n.t('I am filling the application for myself'), value: 'no' },
  { label: i18n.t('I am an Authorized Representative'), value: 'yes' }
];

export const individualRelationships = [
  { label: i18n.t('Agent'), value: '1' },
  { label: i18n.t('Broker'), value: '2' },
  { label: i18n.t('SHIP counselor'), value: '3' },
  { label: i18n.t('Authorized Representative'), value: '4' },
  { label: i18n.t('Other (third party)'), value: '5' },
  { label: i18n.t('Self'), value: '6' },
  { label: i18n.t('I choose not to answer'), value: '7' }
];

export const reasons = [
  {
    label: i18n.t('I am new to Medicare.'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "1"
  },
  {
    label: i18n.t('Annual Enrollment Period (October 15 - December 7).'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "2"
  },
  {
    label: i18n.t('I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage Open Enrollment Period (January 1 - March 31).'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "3"
  },
  {
    label: i18n.t('I recently moved outside of the service area for my current plan, or recently moved and this plan is a new option for me. I moved on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "4"
  },
  {
    label: i18n.t('I recently was released from incarceration. I was released on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "5"
  },
  {
    label: i18n.t('I recently obtained lawful presence status in the United States. I obtained this status on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "6"
  },
  {
    label: i18n.t('I recently had a change in my Medicaid status (new to Medicaid, had a change in level of Medicaid assistance, or lost Medicaid) on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "7"
  },
  {
    label: i18n.t('I recently had a change in my Extra Help paying for Medicare prescription drug coverage (new to Extra Help, had a change in the level of Extra Help, or lost Extra Help) on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "8"
  },
  {
    label: i18n.t('I have both Medicare and Medicaid (or my state helps pay for my Medicare premiums) or I get Extra Help paying for my Medicare prescription drug coverage, but I haven’t had a change.'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "9"
  },
  {
    label: i18n.t('I am moving into, live in, or recently moved out of a Long-Term Care Facility (i.e. a nursing home). I moved/will move into/out of the facility on'),
    hasDateInput: true,
    hasDateInputTo: true,
    hasTextInput: false,
    value: "10"
  },
  {
    label: i18n.t('I recently involuntarily lost my creditable prescription drug coverage (coverage as good as Medicare’s). I lost my drug coverage on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "11"
  },
  {
    label: i18n.t('My plan is ending its contract with Medicare (or my state) and I want to choose a different plan. My enrollment in that plan started on'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "12"
  },
  {
    label: i18n.t('I want to join a Special Needs Plan (C-SNP) that tailors its benefits to my chronic condition.'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "13"
  },
  {
    label: i18n.t('I was enrolled in a Special Needs Plan (D-SNP/C-SNP) but I have lost the special needs qualification required to be in that plan.'),
    hasDateInput: true,
    hasDateInputTo: false,
    hasTextInput: false,
    value: "14"
  },
  {
    label: i18n.t('I was affected by an emergency or major disaster (as declared by the Federal Emergency Management Agency, FEMA) or by federal, state, or local government entity. One of the other statements here applied to me, but I was able to make my enrollment request because of the disaster. Election period missed:'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: true,
    value: "15"
  },
  {
    label: i18n.t('Other'),
    hasDateInput: false,
    hasDateInputTo: false,
    hasTextInput: true,
    value: "16"
  }
]; 